import { ScrollButtonFlatlist } from "../ChatUI/ScrollButtonFlatlist";
import type { PodcastCitation } from "../PodcastDetailApplet/types";
import CitationCard from "./CitationCard";

type CitationCarouselProps = {
	citations: PodcastCitation[];
	onPressCitation?: (citation: PodcastCitation) => void;
};

const CitationCarousel = ({
	citations,
	onPressCitation,
}: CitationCarouselProps) => {
	if (citations.length === 0) {
		return null;
	}

	return (
		<ScrollButtonFlatlist
			data={citations}
			horizontal
			showsHorizontalScrollIndicator={false}
			keyExtractor={(item) => item.id}
			contentContainerStyle={{ gap: 16 }}
			renderItem={({ item }) => (
				<CitationCard citation={item} onPress={onPressCitation} />
			)}
		/>
	);
};

export default CitationCarousel;
